import approvalProcessService from "@services/approvalProcess/approvalProcessService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class ApprovalProcessStore {
  @observable isLoading!: boolean
  @observable detailLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listApprovalProcess: any[] = []
  @observable listApprovalFlow: any

  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.listApprovalProcess = []
    this.listApprovalFlow = {}
  }

  @action
  async create(body: any) {
    this.isLoading = true
    if (!body.id) {
      const result = await approvalProcessService
        .create(body)
        .finally(() => (this.isLoading = false))
      this.detailData = result
      this.tableData.items.push(result)
    }
  }
  @action
  async update(body: any) {
    const result = await approvalProcessService
      .update(body)
      .finally(() => (this.isLoading = false))
    this.tableData.items = this.tableData.items.map((x) => {
      if (x.id === body.id) x = result
      return x
    })
  }

  @action
  async active(id: number, isActive) {
    await approvalProcessService.active(id, isActive)
  }

  @action
  async get(id: number) {
    this.detailLoading = true
    const result = await approvalProcessService
      .get(id)
      .finally(() => (this.detailLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await approvalProcessService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getList(params: any) {
    this.detailLoading = true
    const result = await approvalProcessService
      .getList(params)
      .finally(() => (this.detailLoading = false))
    this.listApprovalProcess = result
  }

  @action
  async getListFlow(params: any) {
    this.detailLoading = true
    const result = await approvalProcessService
      .getListFlow(params)
      .finally(() => (this.detailLoading = false))
    this.listApprovalFlow = result
  }

  @action
  async sendRequest(body: any) {
    this.isLoading = true
    const result = await approvalProcessService
      .sendRequest(body)
      .finally(() => (this.isLoading = false))
    this.listApprovalFlow = result
  }
  @action
  async sendMultiRequest(body: any) {
    this.isLoading = true
    const result = await approvalProcessService
      .sendMultiRequest(body)
      .finally(() => (this.isLoading = false))
    return result
  }
}

export default ApprovalProcessStore
